import { useEffect, useRef } from "react";
import { useConsent } from "../consent/useConsent";
import { initGA, revokeGA } from "./ga";
import { initGTM, updateGTMConsent } from "./gtm";

/**
 * AnalyticsLoader – bezskriptový komponent, ktorý sleduje zmeny súhlasu
 * a podľa toho inicializuje alebo deaktivuje všetky tracking nástroje:
 *   - GA4 (priamy loader – analytics súhlas)
 *   - GTM (spravuje Google Ads – marketing súhlas)
 *   - GTM Consent Mode v2 signály (aktualizované pri každej zmene)
 *
 * Umiestni ho raz do stromu komponentov vnútri <ConsentProvider>.
 */
function AnalyticsLoader() {
  const { consent } = useConsent();
  const prevConsent = useRef(null);

  useEffect(() => {
    if (!consent) return;

    const prevStr = JSON.stringify(prevConsent.current);
    const currStr = JSON.stringify({
      analytics: consent.analytics,
      marketing: consent.marketing,
      preferences: consent.preferences,
    });
    if (prevStr === currStr) return;

    prevConsent.current = {
      analytics: consent.analytics,
      marketing: consent.marketing,
      preferences: consent.preferences,
    };

    // ── 1. GTM Consent Mode v2 – aktualizuj signály pri každej zmene ──
    updateGTMConsent({
      analytics: consent.analytics,
      marketing: consent.marketing,
      preferences: consent.preferences,
    });

    // ── 2. GA4 (priamy loader, nezávislý od GTM) ──
    if (consent.analytics) {
      initGA();
    } else {
      revokeGA();
    }

    // ── 3. GTM (načíta sa raz, ak je udelený analytics ALEBO marketing súhlas) ──
    if (consent.analytics || consent.marketing) {
      initGTM();
    }

  }, [consent]);

  return null;
}

export default AnalyticsLoader;
